/**
 * INFO: cause legacy web use service worker, we need to clear service worker when we deploy new version
 */
export default defineNuxtPlugin(() => {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(registrations => {
      registrations.forEach(registration => registration.unregister())
    })
  }
})
